import {RenderingServices} from '@wallaby-ui/core';

import linkFormatter from './link_formatter';
import {
  ENCOUNTER_DOCUMENT_ROUTE,
  ENCOUNTER_ROUTE,
} from 'src/js/containers/encounter/encounter_constants';
import baseEncounterDocumentLinkStatefullFormatterParams from 'src/js/lib/raw_rendering/base_encounter_document_link_statefull_formatter_params';

/**
 * Returns raw DOM element version of CaseDocumentLinkStatefullFormatter component.
 * @param params
 * @param services
 * @returns {Element|String}
 */
export default function encounterDocumentLinkStatefullFormatter(
  params,
  services: RenderingServices = {}
) {
  const {encounterId, documentId, searchParams} =
    baseEncounterDocumentLinkStatefullFormatterParams(params, services);
  return linkFormatter(
    {
      route: `${ENCOUNTER_ROUTE}/${encounterId}${ENCOUNTER_DOCUMENT_ROUTE}/${documentId}`,
      searchParams,
      ...params,
    },
    services
  );
}
